import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExcelConverter  {
    _originalTypeClassName = "zERP.BO.ExcelConverter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExcelConverter.translate = translateService;
}
this.ExcelConverterKey = null;
this._key = this.ExcelConverterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _ExcelConverterKey:any;
get ExcelConverterKey(): any {
    return this._ExcelConverterKey;
  }
set ExcelConverterKey(value: any) {
    this._ExcelConverterKey = value;
    this._key = value;
  }

static GetPrecisionDigits(options: any,vType: any): any{let precision = options?.CurrencyDecimalAccuracy;
if (vType == Domain.ExcelExporterVariableType.Days) {precision = options?.DaysAccuracy;}else if (vType == Domain.ExcelExporterVariableType.Hours) {precision = options?.HoursAccuracy;}else if (vType == Domain.ExcelExporterVariableType.Rate) {precision = options?.RateAccuracy;}
let excelFormatting = "#.";
for (var i = 0; CLMS.Framework.Number.LessThan(() => i, () => precision); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
excelFormatting = excelFormatting + "0";}

return excelFormatting;
}
static ParseFunctionInvocation(cellValue: any): any{if (cellValue?.indexOf("_") === 0 && Joove.Common.stringContains(cellValue, "(") && Joove.Common.stringContains(cellValue, ")")) {let func = new Domain.PrintingTemplateFunction();let splittedValues = System.split(cellValue, '(');let functionToExecute = splittedValues[0];functionToExecute = functionToExecute?.substr(1);functionToExecute = functionToExecute?.trim();func.Name = functionToExecute;let argumentsToUse = splittedValues[1];argumentsToUse = Joove.Common.replaceAll(argumentsToUse, ")", "");argumentsToUse = argumentsToUse?.trim();for (let _iarg = 0; _iarg < (System.split(argumentsToUse, ',') == null ? 0 : System.split(argumentsToUse, ',').length); _iarg++) {let arg = System.split(argumentsToUse, ',')[_iarg];let functionArgument = new Domain.PrintingTemplateFunctionArgument();functionArgument.Value = arg;func?.Arguments?.add(functionArgument);}return func;}
return null;
}
static ResolveFunctionCall(entity: any,func: any,context: any): any{switch (entity) {case Domain.ExcelConverterEntity.PayrollSummary:
{
return Domain.PayrollSummaryExporter.ResolveFunctionInvocation(func, context);}
case Domain.ExcelConverterEntity.EmployeeOvertime:
{
return Domain.OvertimeExporter.ResolveFunctionInvocation(func, context);}
case Domain.ExcelConverterEntity.PeriodOvertime:
{
return Domain.OvertimeExporter.ResolveFunctionInvocation(func, context);}
default:
{
return "NOT IMPLEMENTED FUNCTION CASE: " + entity;}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ExcelConverterKey == null || $this.ExcelConverterKey == 0;
            }


}